export default {
  // 通用动作
  'common.save': '保存',
  'common.cancel': '取消',
  'common.confirm': '确认',
  'common.delete': '删除',
  'common.edit': '编辑',
  'common.add': '新增',
  'common.create': '新增',
  'common.update': '修改',
  'common.search': '搜索',
  'common.reset': '重置',
  'common.refresh': '刷新',
  'common.filter': '筛选',
  'common.submit': '提交',
  'common.close': '关闭',
  'common.back': '返回',
  'common.loading': '加载中',
  'common.success': '操作成功',
  'common.failed': '操作失败',
  'common.sendFailed': '发送失败',
  'common.registerFailed': '注册失败',
  'common.resetFailed': '重置失败',
  'common.loginFailed': '登录失败',
  'common.empty': '暂无数据',
  'common.more': '更多',
  'common.noPermission': '无权限访问该页面',

  // 音频播放器
  'audio.play': '播放',
  'audio.pause': '暂停',
  'audio.download': '下载',
  'audio.loadFailed': '音频加载失败',
  'audio.waveLimited': '波形解析受限，仍可正常播放',

  // 列表通用
  'list.total': '共有 {total} 条记录',

  // 注册来源渠道枚举（与后端 attr 渠道枚举一一对应）
  'attr.channel.paid_ads': '付费广告',
  'attr.channel.social': '社交媒体',
  'attr.channel.email_sms': '邮件短信',
  'attr.channel.invite': '邀请分享',
  'attr.channel.qr_offline': '线下扫码',
  'attr.channel.organic_search': '搜索引擎',
  'attr.channel.referral': '外部引荐',
  'attr.channel.direct': '直接访问',
  'attr.channel.unknown': '未识别',

  // 侧边栏导航（各模块共用的固定入口）
  'nav.admin': '管理',
  'nav.admin.short': '管理',
  'nav.setting': '设置',
  'nav.admin.user': '用户管理',
  'nav.admin.setting': '功能设置',
  'nav.admin.register': '注册登录',
  'nav.admin.package': '点数套餐',
  'nav.admin.order': '点数购买记录',
  'nav.admin.pay': '支付设置',
  'nav.admin.notify': '运营通知',
  'nav.admin.attr': '渠道分析',
  'nav.setting.basic': '基本设置',
  'nav.setting.upload': '文件上传',
  'nav.setting.file': '文件管理',
  'nav.setting.smtp': '邮件设置',
  'nav.setting.sms': '短信设置',
  'nav.setting.about': '关于系统',

  // 外框（侧边栏底部操作 / 账号弹窗）
  'shell.account': '账号',
  'shell.feedback': '反馈',
  'shell.settings': '设置',
  'shell.account.title': '账号设置',
  'shell.logout': '退出',
  'shell.logout.title': '退出登录',
  'shell.logout.desc': '确定要退出当前账号吗？',
  'shell.logout.ok': '退出',

  // 账号设置（弹窗 Tab 表单）
  'shell.account.tabAvatar': '修改头像',
  'shell.account.avatarUpload': '上传',
  'shell.account.avatarUploadNew': '上传头像',
  'shell.account.avatarReset': '恢复默认',
  'shell.account.avatarUndo': '撤销',
  'shell.account.avatarUndoSuccess': '已恢复上一张头像',
  'shell.account.avatarEmptyHint': '当前使用默认头像，点击头像或「上传头像」即可更换',
  'shell.account.avatarFormatHint': '支持 JPG / PNG，建议 1:1，不小于 200×200，不超过 5MB',
  'shell.account.avatarResetTitle': '恢复默认头像',
  'shell.account.avatarResetDesc': '将移除当前头像并恢复为默认头像，确定继续吗？',
  'shell.account.avatarUploadSuccess': '头像上传成功',
  'shell.account.avatarUploadFailed': '头像上传失败',
  'shell.account.avatarResetSuccess': '已恢复默认头像',
  'shell.account.tabUsername': '修改用户名',
  'shell.account.tabEmail': '修改邮箱',
  'shell.account.tabPassword': '修改密码',
  'shell.account.currentUsername': '当前用户名',
  'shell.account.newUsername': '新用户名',
  'shell.account.newUsernamePlaceholder': '请输入新用户名',
  'shell.account.saveUsername': '保存用户名',
  'shell.account.usernameRequired': '请输入新用户名',
  'shell.account.usernameSuccess': '用户名更新成功',
  'shell.account.currentEmail': '当前邮箱',
  'shell.account.emailUnset': '未设置',
  'shell.account.newEmail': '新邮箱',
  'shell.account.newEmailPlaceholder': '用于找回密码',
  'shell.account.newEmailPlaceholderPlain': '输入新的邮箱',
  'shell.account.saveEmail': '保存邮箱',
  'shell.account.emailRequired': '请输入新邮箱',
  'shell.account.emailSuccess': '邮箱更新成功',
  'shell.account.emailCode': '邮箱验证码',
  'shell.account.emailCodePlaceholder': '请输入邮箱验证码',
  'shell.account.emailCodeRequired': '请输入邮箱验证码',
  'shell.account.tabPhone': '修改手机号',
  'shell.account.currentPhone': '当前手机号',
  'shell.account.phoneUnset': '未设置',
  'shell.account.newPhone': '新手机号',
  'shell.account.newPhonePlaceholder': '请输入新的手机号',
  'shell.account.savePhone': '保存手机号',
  'shell.account.phoneRequired': '请输入新手机号',
  'shell.account.phoneInvalid': '手机号格式不正确',
  'shell.account.phoneSuccess': '手机号更新成功',
  'shell.account.phoneCode': '手机验证码',
  'shell.account.phoneCodePlaceholder': '请输入手机验证码',
  'shell.account.phoneCodeRequired': '请输入手机验证码',
  'shell.account.sendCode': '发送验证码',
  'shell.account.codeResend': '{seconds} 秒后重发',
  'shell.account.codeSent': '验证码已发送',
  'shell.account.codeSendFailed': '验证码发送失败',
  'shell.account.currentPassword': '当前密码',
  'shell.account.currentPasswordPlaceholder': '请输入当前密码',
  'shell.account.newPassword': '新密码',
  'shell.account.newPasswordPlaceholder': '请输入新密码',
  'shell.account.confirmPassword': '确认新密码',
  'shell.account.confirmPasswordPlaceholder': '请再次输入新密码',
  'shell.account.savePassword': '保存密码',
  'shell.account.passwordAllRequired': '请填写所有密码字段',
  'shell.account.passwordMismatch': '两次输入的新密码不一致',
  'shell.account.passwordSuccess': '密码更新成功',
  'shell.account.updateFailed': '更新失败',

  // 账号弹窗分节（基础包可选模块）
  'shell.account.tabAccount': '基础信息',
  'shell.account.tabInfo': '修改信息',
  'shell.account.tabRecharge': '点数充值',
  'shell.account.roleAdmin': '管理员',
  'shell.account.roleUser': '用户',
  'shell.account.balance': '点数',
  'shell.account.pointsUnit': '点',
  'shell.account.goRecharge': '去充值',
  'shell.account.totalPurchased': '累计充值',
  'shell.account.totalConsumed': '累计消耗',
  'shell.account.channel.alipay': '支付宝',
  'shell.account.channel.wechat': '微信支付',
  'shell.account.channel.connect': '魔众 Connect',
  'shell.account.recharge.package': '点数套餐',
  'shell.account.recharge.channel': '支付方式',
  'shell.account.recharge.credit': '到账点数',
  'shell.account.recharge.bonus': '赠送',
  'shell.account.recharge.submit': '立即充值',
  'shell.account.recharge.success': '充值成功，点数已到账',
  'shell.account.recharge.failed': '充值失败',
  'shell.account.recharge.emptyPackage': '暂无可用套餐',
  'shell.account.recharge.noChannel': '暂无可用的支付方式',
  'shell.account.recharge.connectHint': '支持支付宝 / 微信扫码支付',
  'shell.account.recharge.qrTitle': '扫码支付',
  'shell.account.recharge.qrHint': '请使用微信或支付宝扫描二维码完成支付',
  'shell.account.recharge.qrOrderNo': '订单号',
  'shell.account.recharge.qrWaiting': '等待支付中，完成后将自动到账...',
  'shell.account.recharge.qrSuccess': '支付成功，点数已到账',
  'shell.account.recharge.qrExpired': '二维码已过期，请刷新',
  'shell.account.recharge.qrRefresh': '刷新',
  'shell.account.recharge.qrFailed': '二维码生成失败',
  'shell.account.recharge.openPayPage': '打开支付页面',
  'shell.account.recharge.agreementPrefix': '点击充值即表示同意',
  'shell.account.recharge.agreementName': '《充值服务协议》',
  'shell.account.recharge.agreementTitle': '充值服务协议',
  'shell.account.recharge.agreementEmpty': '暂无内容',
  'shell.account.order.title': '订单',
  'shell.account.order.view': '订单',
  'shell.account.order.tabOrders': '点数购买记录',
  'shell.account.order.tabLogs': '点数流水',
  'shell.account.order.colOrderNo': '订单号',
  'shell.account.order.colTitle': '套餐',
  'shell.account.order.colPrice': '金额',
  'shell.account.order.colRefundAmount': '已退金额',
  'shell.account.order.colCredit': '点数',
  'shell.account.order.colStatus': '状态',
  'shell.account.order.colCreatedAt': '时间',
  'shell.account.order.colChange': '变动',
  'shell.account.order.colBalance': '余额',
  'shell.account.order.colRemark': '说明',
  'shell.account.order.empty': '暂无订单',
  'shell.account.order.emptyLog': '暂无流水记录',
  'shell.account.order.statusNew': '待支付',
  'shell.account.order.statusPayed': '已支付',
  'shell.account.order.statusClosed': '已关闭',
  'shell.account.order.statusRefunded': '已退款',
  'shell.account.order.statusPartRefunded': '部分退款',

  // 系统监控（公共组件 OSMonitor）
  'osMonitor.title': '系统状态',
  'osMonitor.autoRefresh': '5秒自动刷新',
  'osMonitor.cores': '{count} 核心 · {model}',
  'osMonitor.legendCpu': 'CPU',
  'osMonitor.legendMem': '内存',
  'osMonitor.legendProcess': '进程内存',
  'osMonitor.mem': '内存',
  'osMonitor.processMem': '进程内存',
  'osMonitor.disk': '磁盘',
  'osMonitor.uptime': '运行时间',
  'osMonitor.heapUsed': '堆内存',
  'osMonitor.heapTotal': '堆系统',
  'osMonitor.external': '栈内存',
  'osMonitor.arrayBuffers': '其他',
  'osMonitor.realtimeChart': '实时监控曲线',
  'osMonitor.collecting': '数据采集中，请稍候...',
  'osMonitor.loadFailed': '加载失败，请刷新重试',

  // Markdown 查看器（公共组件 MarkdownViewer）
  'markdownViewer.copy': '复制',
  'markdownViewer.copied': '已复制',
  'markdownViewer.copyFailed': '复制失败',
}
